import { useTranslate } from 'hooks/useTranslate';
import { FC, useMemo } from 'react';
import { Modal } from 'react-bootstrap';

import actionTypes from 'constants/actionTypes';

import { usePublishTradingOfferModal } from '../context/PublishTradingOfferModalContext';

const PublishTradingOfferModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = usePublishTradingOfferModal();

  const isSellOffer = data.tradingOffer?.type === 'SELL';

  const buttonLabel = useMemo(() => {
    if (data.modalActionType === actionTypes.EDIT) return t('EditOffer');
    return isSellOffer
      ? t('PublishSellOfferButton')
      : t('PublishBuyOfferButton');
  }, [data.modalActionType, isSellOffer, t]);

  const isReadOnlyView = data.modalActionType === actionTypes.VIEW;

  return (
    <>
      {!isReadOnlyView && (
        <Modal.Footer className="border-top d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={actions.handleCloseModal}
          >
            {t('Cancel')}
          </button>
          <button
            type="button"
            className="btn btn-success"
            disabled={!data.isTermsAndConditionsAccepted}
            onClick={actions.handlePublishTradingOffer}
          >
            <em className="icon ni ni-check mr-1" />
            <span>{buttonLabel}</span>
          </button>
        </Modal.Footer>
      )}
    </>
  );
};

export default PublishTradingOfferModalFooter;
